import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { ThemeList, ThemeService } from '../../service/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnDestroy {
  @Input() boundaryLinks: boolean;
  @Input() count: number;
  @Input() ellipses: boolean;
  @Input() rotate: boolean;
  @Input() pageSize: number;
  @Input() newDesign = false;
  @Input() maxSize = 5;
  @Output() pageSizeChange = new EventEmitter();

  @Input() page: number;
  @Output() pageChange = new EventEmitter();
  @Input() noneSize: boolean;
  @Input() pageTitle: string;
  @Input() memosPage: boolean;
  isMobile = this.themeService.isMobile();
  themeList: ThemeList;
  paginationDropdown = ['10', '20', '30', '40', '50', '100'];
  paginationMemosDropdown = ['10', '20', '30', '40', '50', '100'];
  themeSubscription: Subscription[] = [];

  constructor(private themeService: ThemeService) {
    this.themeSubscription.push(
      this.themeService.data.subscribe((theme) => {
        this.themeList = theme;
      }),
    );
  }

  ngOnDestroy(): void {
    this.themeSubscription?.forEach((item) => {
      try {
        item.unsubscribe();
      } catch (_) {}
    });
  }

  changePageSizeEmit(e) {
    this.page = 1;
    this.pageSize = e;
    this.pageSizeChange.emit(this.pageSize);
  }

  changePageEmit() {
    this.pageChange.emit(this.page);
  }

  getJustifyClass() {
    const isIpadSize = window.innerWidth < 1367;
    const isMobileSize = window.innerWidth < 577;

    if (
      isMobileSize ||
      (this.pageTitle === 'userPage' && isIpadSize)
    ) {
      return 'justify-content-end';
    } else {
      return 'justify-content-between';
    }
  }
}
